import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

const CustomTabs = ({ options }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const matchingTab = options.find(
    (option) =>
      currentPath === option.link || currentPath.startsWith(option.link + '/')
  );

  const activeComponent = matchingTab
    ? matchingTab.component
    : options[0]?.component || null;

  return (
    <Routes>
      <Route path="*" element={activeComponent} />
    </Routes>
  );
};

export default CustomTabs;
